import 'css-chunk:src/image/image.module.scss';export default {
  "figureContainer": "image-module__figureContainer___jYA2e",
  "image": "image-module__image___vystJ",
  "figure-hasBorder": "image-module__figure-hasBorder___fP8EU",
  "figure-hasBoxShadow": "image-module__figure-hasBoxShadow___bqnjE",
  "figure-hasRoundedCorners": "image-module__figure-hasRoundedCorners___aJWq0"
};